// DashboardParent.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import BaseLayout from './BaseLayout';
import ForceLogoutRedirect from './ForceLogoutRedirect';
import ParentSmartScheduler from './ParentSmartScheduler';
import ParentVisitsToday from './ParentVisitsToday';
import ParentVisitsCalendar from './ParentVisitsCalendar';
import ParentChildren from './ParentChildren';
import Messages from './Messages';
import ProfileSettings from './ProfileSettings';
import ParentsAvailability from './ParentsAvailability';
import ParentStudentProgressReport from './ParentStudentProgressReport';
import ParentDocuments from './ParentDocuments';

// ✅ NOVO: Instruments (parent)
//import ParentInstruments from './ParentInstruments';
import ParentPortalInstruments from './ParentPortalInstruments';
import InstrumentWorkspace from './InstrumentWorkspace';

const DashboardParent = () => {
  const location = useLocation();
  return (
    <BaseLayout role="parent">
      <Routes location={location}>
        <Route path="/" element={<ParentVisitsToday />} />
        <Route path="students" element={<ParentChildren />} />
        <Route path="visits" element={<ParentVisitsCalendar />} />
        <Route path="reports" element={<ParentStudentProgressReport />} />
        <Route path="scheduler" element={<ParentSmartScheduler />} />
        <Route path="availability" element={<ParentsAvailability />} />
        <Route path="profile" element={<ProfileSettings />} />
        <Route path="docs" element={<ParentDocuments />} />

        <Route path="messages" element={<Messages mode="parent" />} />

        {/* ✅ NOVO: Instruments */}
        <Route path="instruments" element={<ParentPortalInstruments />} />
		<Route path="instrument-submissions/:id" element={<InstrumentWorkspace />} />

        <Route path="*" element={<ForceLogoutRedirect />} />
      </Routes>
    </BaseLayout>
  );
};

export default DashboardParent;


